// extracted by mini-css-extract-plugin
export default {"not_verified":"LawFirmNotVerified_not_verified__i0AIS"};